import React, { useEffect, useState } from "react";
import Logo from "../asset/images/Logo1.png";
import { FaBarsStaggered } from "react-icons/fa6";
import { Link, useNavigate } from "react-router-dom";
import { FaRegUser } from "react-icons/fa";


const DashHeader = ({ toggleMenu }) => {
  const navigate = useNavigate();

  // User state
  const [user, setUser] = useState({
     firstName: "",
        lastName: "",
        userPlan: ""
  });


  // Load user data
  useEffect(() => {
    const savedUser = localStorage.getItem("teslaUserInfo");
    if (savedUser) {
      const userData = JSON.parse(savedUser);
      setUser({
        firstName: userData.firstName || "",
        lastName: userData.lastName || "",
        userPlan: userData.userPlan || ""
      });
    }
    else {
      // navigate("/");
    }
  }, [navigate]);


  return (
    <header className="dash">
      <div className="head_cover">


        {/* Logo */}
        <Link to="/dashboard">
          <nav className="head_container">
            <img src={Logo} alt="logo" />
            {/* <h5 className="logo">Campus Connect</h5> */}
          </nav>
        </Link>


        {/* Right side */}
        <nav className="head_container">
          <button className="bar" onClick={toggleMenu}>
            <FaBarsStaggered />
          </button>
          <button style={{textTransform: "capitalize"}}><FaRegUser /> {user.firstName} {user.lastName}</button>
          <Link to="/deposit"><button className="main">
            Deposit
          </button></Link>
          <Link to="/withdrawal"><button className="main" >
            Withdrawal
          </button></Link>
        </nav>
      </div>
    </header>
  );
};

export default DashHeader;
